(function () {
  function readJSON(id) { var el = document.getElementById(id); try { return el ? JSON.parse(el.textContent || '[]') : []; } catch (_) { return []; } }
  function normalize(a) { return (a || []).map(function (x) { return String(x || '').trim().toLowerCase(); }); }
  function keyFromVariant(v) { var opts = Array.isArray(v.options) ? v.options : [v.option1, v.option2, v.option3].filter(Boolean); return normalize(opts).join('||'); }
  function buildMaps(pv, sv) { var idToKey = {}, sampleMap = {}; pv.forEach(function (v) { idToKey[String(v.id)] = keyFromVariant(v); }); sv.forEach(function (v) { sampleMap[keyFromVariant(v)] = String(v.id); }); return { idToKey: idToKey, sampleMap: sampleMap }; }
  function currentVariantId(pv) {
    var el = document.querySelector('form[action="/cart/add"] input[name="id"], input[name="id"][type="hidden"], select[name="id"], input[name="id"]');
    if (el && el.value) return String(el.value);
    if (pv && pv.length === 1) return String(pv[0].id);
    var qs = new URLSearchParams(location.search).get('variant'); if (qs) return String(qs);
    return '';
  }
  function firstAvailableSample(sv) { var a = sv.find(function (v) { return v.available; }); return a ? String(a.id) : (sv[0] ? String(sv[0].id) : ''); }
  function showMsgAutoHide(ok) { var m = document.querySelector('.sample-order-message'); if (!m) return; m.textContent = ok ? '✅ Sample added to cart' : 'Could not add sample'; m.style.display = 'block'; m.style.background = ok ? 'var(--bg-accent)' : '#fee'; clearTimeout(showMsgAutoHide.t); showMsgAutoHide.t = setTimeout(function () { m.style.display = 'none'; }, 2200); }
  function goToCart() { window.location.href = (window.theme && window.theme.routes && window.theme.routes.cart_url) ? window.theme.routes.cart_url : '/cart'; }

  // Single delegated listener, attached once — no re-binding, so no duplicate handlers / double-adds.
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-sample-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.busy) return;         // guard against rapid double-clicks
    btn.dataset.busy = '1';
    btn.disabled = true;
    try {
      var pv = readJSON('current-product-variants');
      var sv = readJSON('sample-variants');
      if (!pv.length || !sv.length) { showMsgAutoHide(false); return; }
      var maps = buildMaps(pv, sv);
      var mainId = currentVariantId(pv);
      if (!mainId) { showMsgAutoHide(false); return; }
      var key = maps.idToKey[mainId] || '';
      var sampleId = key ? maps.sampleMap[key] : '';
      if (!sampleId) sampleId = firstAvailableSample(sv);
      if (!sampleId) { showMsgAutoHide(false); return; }
      var r = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: sampleId, quantity: 1 }) });
      if (!r.ok) { showMsgAutoHide(false); return; }
      try { await r.json(); } catch (_) {}
      goToCart();                          // go to the cart PAGE instead of opening the drawer
    } catch (_) {
      showMsgAutoHide(false);
    } finally {
      btn.dataset.busy = '';
      btn.disabled = false;
    }
  });
})();